import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getAllAreas,
  filterAreasTurnOverRequest,
} from "../../services/areasService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getAreas(action) {
  const { restaurantId, log } = action;
  try {
    const token = getToken().get("idToken");
    const organizationId = localStorage.getItem("organizationId");
    const response = yield call(
      getAllAreas,
      token,
      restaurantId,
      organizationId,
      log
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_AREAS_SUCCESS,
        areas: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* filterAreasTurnOver({ filteredAreaIds, startDate, endDate }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      filterAreasTurnOverRequest,
      token,
      filteredAreaIds,
      startDate,
      endDate
    );
    if (response[0] === 200) {
      yield put({
        type: actions.FILTER_BY_AREAS_SUCCESS,
        areasTurnOver: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* filterForOneAreaTurnOver({
  filteredAreaIds,
  startDate,
  endDate,
}) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      filterAreasTurnOverRequest,
      token,
      filteredAreaIds,
      startDate,
      endDate
    );
    if (response[0] === 200) {
      var colSum = [];
      for (var i = 1; i < response[1][0].length; i++) {
        var col = 0.0;
        for (var z = 0; z < response[1].length; z++) {
          col += parseFloat(response[1][z][i]);
        }
        colSum.push(col);
      }

      yield put({
        type: actions.FILTER_FOR_ONE_AREA_SUCCESS,
        areaTurnOver: response[1],
        colsTotalSum: colSum,
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_AREAS_REQUEST, getAreas),
    yield takeEvery(actions.FILTER_BY_AREAS_REQUEST, filterAreasTurnOver),
    yield takeEvery(
      actions.FILTER_FOR_ONE_AREA_REQUEST,
      filterForOneAreaTurnOver
    ),
  ]);
}
